import { render } from "./EditTac.vue?vue&type=template&id=0048a3d7"
import script from "./EditTac.vue?vue&type=script&lang=js"
export * from "./EditTac.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__